import React from 'react';

import PropTypes from 'prop-types';

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';

function ConfirmationModal({ onClose, onClickConfirm, content, ...props }) {
  return (
    <Dialog
      onClose={onClose}
      aria-labelledby='title'
      aria-describedby='description'
      {...props}
    >
      <DialogTitle id='title'>{content.title}</DialogTitle>
      <DialogContent>
        <DialogContentText id='description'>
          {content.description}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button color='blue' onClick={onClose}>
          No
        </Button>
        <Button color='blue' onClick={onClickConfirm} autoFocus>
          Yes
        </Button>
      </DialogActions>
    </Dialog>
  );
}

ConfirmationModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  onClickConfirm: PropTypes.func.isRequired,
  content: PropTypes.shape({
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
  }),
};

export default ConfirmationModal;
